export default {
  createNewDdProject: '全新创建',
  createDdProjectFromTem: '按模版创建',
  createBaseDdProject: '交付部署方案基础信息'
}
